/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
// for native select component

const formatSelectOptions = <R,>(
  options: any[],
  optionsToExclude: any[] | null,
  isValueById: boolean = false,
  setterFunction: Function
): R => {
  if (!options || !Array.isArray(options) || options.length === 0) return [] as unknown as R;
  const reshapedOptions = options.map((option) => ({
    label:
      (setterFunction && setterFunction(option).label) ||
      option.name ||
      option.title ||
      option.label ||
      option.value ||
      option.first_name,
    value:
      (setterFunction && setterFunction(option).value) ||
      (isValueById && (option.id || option.hash_id)) ||
      option.name ||
      option.title ||
      option.value ||
      option.label ||
      option.first_name,
    id:
      (setterFunction && setterFunction(option).id) ||
      option.id ||
      option.hash_id,
  }));
  // the purpose of this is to remove the options that are already selected.
  if (Array.isArray(optionsToExclude) && optionsToExclude.length > 0) {
    return removeSelectsFromOptions(reshapedOptions, optionsToExclude) as unknown as R;
  }
  // if optionsToExclude is not provided, return the reshaped options.
  return reshapedOptions as unknown as R;
};

const removeSelectsFromOptions = (options: any[], optionsToExclude: any[]) => {
  const filteredOptions = options.filter(
    (group) =>
      !optionsToExclude.find(
        (g) =>
          g.value === group.value ||
          g.label === group.label ||
          g.id === group.id
      )
  );
  return filteredOptions;
};

export default formatSelectOptions;
